import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "./ShippingAddress.module.scss";
import { editAddress, follow, getSlug } from "../../api";
import shippingLocationIcon from "../../static/icons/shipping-location.svg";
import ShippingAddressModal from "../../components/Modal/ShippingAddressModal";
import EditAddressModal from "../../components/Modal/EditAddressModal";
import MenuModal from "../../components/Modal/MenuModal";
import UserSettingModal from "../../components/Modal/UserSettingModal";
import { getAddresses } from "../../api";
import spin from "../../static/icons/spin-v2.svg";
import menuIcon from "../../static/icons/menu.svg";

const ShippingAddress = ({
  match,
  location,
  isPublic,
  setIsUploadSelectionOpened,
}) => {
  const { userInfo } = useSelector((state) => state.authReducer);
  const history = useHistory();

  const [isShippingAddressModal, setShippingAddressModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [addressToEdit, setAddressToEdit] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const onUpdateAddresses = () => {
    getAddresses()
      .then((res) => {
        setAddresses(res.response["addresses"]); // Set addresses state to res.body
      })

      .catch((err) => {
        console.log("The exception", err);
      });
  };

  const onEditAddress = (data) => {
    editAddress(data).then(({ response }) => {
      console.log("response", response);
    });
  };
  useEffect(() => {
    getAddresses()
      .then((res) => {
        setAddresses(res.response["addresses"]); // Set addresses state to res.body
      })

      .catch((err) => {
        console.log("The exception", err);
      });
  }, []);

  useEffect(() => {
    localStorage.removeItem("lastUrl");
  }, []);

  const removeZindexes = () => {
    const cards = document.querySelectorAll('[class^="Nav"]');
    const stores = document.querySelectorAll('[class^="Store"]');

    if (cards.length > 0) {
      cards.forEach((card) => {
        card.style.zIndex = "-9999";
      });
    }

    if (stores.length > 0) {
      stores.forEach((store) => {
        store.style.zIndex = "-9999";
      });
    }
  };
  const resetZindexes = () => {
    const cards = document.querySelectorAll('[class^="Nav"]');
    const stores = document.querySelectorAll('[class^="Store"]');

    if (cards.length > 0) {
      cards.forEach((card) => {
        card.style.zIndex = "1";
      });
    }

    if (stores.length > 0) {
      stores.forEach((store) => {
        store.style.zIndex = "1";
      });
    }
  };

  return (
    <div className={styles.shippingContainer}>
      {/* Left Sidebar */}
      <div className={styles.leftSidebar}>
        <div className={styles.sidebarTop}>
          <img src={spin} alt="Logo" className={styles.logo} />
        </div>
        <div className={styles.sidebarIcons}>
          <div className={styles.iconButton} onClick={() => setIsMenuOpen(true)}>
            <img src={menuIcon} alt="Menu" className={styles.menuIcon} />
          </div>
          <div className={styles.iconButton}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="15.5" stroke="currentColor" strokeWidth="1"/>
              <line x1="16" y1="10" x2="16" y2="22" stroke="currentColor" strokeWidth="1"/>
              <line x1="10" y1="16" x2="22" y2="16" stroke="currentColor" strokeWidth="1"/>
            </svg>
          </div>
          <div className={styles.iconButton}>
            <img 
              src={userInfo?.image?.url || "https://placehold.co/40x40"} 
              alt="Profile" 
              className={styles.profileIcon}
            />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className={styles.mainContent}>
        {/* Mobile Header */}
        <div className={styles.mobileHeader}>
          <div className={styles.backButton} onClick={() => history.goBack()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18" fill="none">
              <path d="M9.72727 1L1 9M1 9L9.72727 17M1 9H25" stroke="black" strokeWidth="1.2" strokeLinecap="round"/>
            </svg>
          </div>
          <div className={styles.mobileLogo}>
            <img src={spin} alt="Logo" />
          </div>
        </div>

        {/* Cover Photo Section */}
        <div className={styles.coverSection}>
          <div 
            className={styles.coverPhoto}
            style={{
              backgroundImage: userInfo?.cover_photo?.url 
                ? `url(${userInfo.cover_photo.url})` 
                : 'url(https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1200&h=466&fit=crop)'
            }}
          />
          <div className={styles.profileIconContainer}>
            <img 
              src={userInfo?.image?.url || "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop"} 
              alt="Profile" 
              className={styles.mainProfileIcon}
            />
          </div>
        </div>

        {/* Shipping Addresses Title */}
        <div className={styles.shippingTitle}>SHIPPING ADDRESSES</div>

        {/* Items Count */}
        <div className={styles.itemsCount}>{addresses.length} Items</div>

        {/* Address List or Empty State */}
        {addresses.length > 0 ? (
          <div className={styles.addressList}>
            {addresses.map((address, index) => (
              <div key={index} className={styles.addressCard}>
                <div className={styles.addressIconAndText}>
                  <div className={styles.addressIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 30 31" fill="none">
                      <path d="M15 1.09961C15.4525 1.09961 15.8895 1.27045 16.2246 1.5791L16.2266 1.58105L28.3076 12.6387V12.6396C28.4473 12.7683 28.5665 12.9178 28.6602 13.083L28.7451 13.2529C28.8215 13.4275 28.87 13.6133 28.8896 13.8027L28.9004 13.9941V28.0654C28.8995 28.3561 28.8303 28.6418 28.7002 28.8994L28.6406 29.0078C28.4719 29.2929 28.2306 29.5264 27.9424 29.6846C27.6803 29.8282 27.3867 29.9029 27.0889 29.9004H19.833C19.6733 29.9003 19.5189 29.836 19.4043 29.7207H19.4053C19.2906 29.6052 19.2257 29.448 19.2256 29.2832V21.9805C19.2256 21.5 19.0357 21.0383 18.6973 20.6973C18.3585 20.356 17.8978 20.1631 17.417 20.1631H12.584C12.1629 20.1631 11.7573 20.3107 11.4355 20.5762L11.3037 20.6973C10.9652 21.0383 10.7754 21.4998 10.7754 21.9805V29.2832C10.7753 29.4482 10.7102 29.6053 10.5957 29.7207C10.4814 29.8359 10.3269 29.9004 10.167 29.9004H2.91504C2.65846 29.9013 2.40418 29.8464 2.16992 29.7402C1.93725 29.6348 1.72918 29.4803 1.55957 29.2871C1.25674 28.9348 1.09314 28.4819 1.10059 28.0146V13.9941C1.1007 13.7389 1.15292 13.486 1.25488 13.2529C1.35693 13.0197 1.5053 12.8102 1.69141 12.6387L13.7744 1.58105L13.7754 1.5791C14.1104 1.27038 14.5475 1.09965 15 1.09961Z" stroke="black" strokeWidth="1.2"/>
                    </svg>
                  </div>
                  <div className={styles.addressText}>
                    {address.address}, {address.city.name}
                  </div>
                </div>
                <button
                  className={styles.editButton}
                  onClick={() => {
                    removeZindexes();
                    setAddressToEdit(address);
                    setEditModal(true);
                  }}
                >
                  Edit
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" width="29" height="30" viewBox="0 0 30 31" fill="none">
                <path d="M15 1.09961C15.4525 1.09961 15.8895 1.27045 16.2246 1.5791L16.2266 1.58105L28.3076 12.6387V12.6396C28.4473 12.7683 28.5665 12.9178 28.6602 13.083L28.7451 13.2529C28.8215 13.4275 28.87 13.6133 28.8896 13.8027L28.9004 13.9941V28.0654C28.8995 28.3561 28.8303 28.6418 28.7002 28.8994L28.6406 29.0078C28.4719 29.2929 28.2306 29.5264 27.9424 29.6846C27.6803 29.8282 27.3867 29.9029 27.0889 29.9004H19.833C19.6733 29.9003 19.5189 29.836 19.4043 29.7207H19.4053C19.2906 29.6052 19.2257 29.448 19.2256 29.2832V21.9805C19.2256 21.5 19.0357 21.0383 18.6973 20.6973C18.3585 20.356 17.8978 20.1631 17.417 20.1631H12.584C12.1629 20.1631 11.7573 20.3107 11.4355 20.5762L11.3037 20.6973C10.9652 21.0383 10.7754 21.4998 10.7754 21.9805V29.2832C10.7753 29.4482 10.7102 29.6053 10.5957 29.7207C10.4814 29.8359 10.3269 29.9004 10.167 29.9004H2.91504C2.65846 29.9013 2.40418 29.8464 2.16992 29.7402C1.93725 29.6348 1.72918 29.4803 1.55957 29.2871C1.25674 28.9348 1.09314 28.4819 1.10059 28.0146V13.9941C1.1007 13.7389 1.15292 13.486 1.25488 13.2529C1.35693 13.0197 1.5053 12.8102 1.69141 12.6387L13.7744 1.58105L13.7754 1.5791C14.1104 1.27038 14.5475 1.09965 15 1.09961Z" stroke="black" strokeWidth="1.2"/>
              </svg>
            </div>
            <div className={styles.emptyTitle}>Your address book is empty.</div>
            <div className={styles.emptySubtitle}>Your shipping addresses will appear here once added.</div>
          </div>
        )}

        {/* Add New Address Button */}
        <div className={styles.addButtonContainer}>
          <button
            className={styles.addNewAddressButton}
            onClick={() => {
              removeZindexes();
              setShippingAddressModal(true);
            }}
          >
            ADD NEW ADDRESS
          </button>
        </div>
      </div>

      {isShippingAddressModal && (
        <ShippingAddressModal
          isOpened={isShippingAddressModal}
          onUpdateAddresses={onUpdateAddresses}
          onClose={() => {
            resetZindexes();
            setShippingAddressModal(false);
          }}
        />
      )}

      {editModal && (
        <EditAddressModal
          isOpened={editModal}
          onUpdateAddresses={onUpdateAddresses}
          onClose={() => {
            resetZindexes();

            setEditModal(false);
          }}
          addressInfo={addressToEdit}
        />
      )}

      {isMenuOpen && (
        <MenuModal
          onClose={() => setIsMenuOpen(false)}
          setIsSettingsClicked={() => {
            setIsMenuOpen(false);
            setIsSettingsOpen(true);
          }}
        />
      )}

      {isSettingsOpen && (
        <UserSettingModal
          onClose={() => setIsSettingsOpen(false)}
          onBackClick={() => {
            setIsSettingsOpen(false);
            setIsMenuOpen(true);
          }}
          onDropDownClick={() => setIsSettingsOpen(false)}
          setSettingsModal={() => setIsSettingsOpen(false)}
        />
      )}
    </div>
  );
};
export default ShippingAddress;
